// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3Hk_V){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3uDZR .dualColumn_3O_Qx{display:flex;align-content:space-between}.nsAddressForm_3uDZR .dualColumn_3O_Qx .firstCol_264_Z{margin-right:20px}.optional_2OkCa{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3Hk_V",
	"nsAddressForm": "nsAddressForm_3uDZR",
	"dualColumn": "dualColumn_3O_Qx",
	"firstCol": "firstCol_264_Z",
	"optional": "optional_2OkCa"
};
module.exports = exports;
